import {
  GET_HIDDEN_BLOCK_TYPES,
  TOGGLE_HIDDEN_BLOCK_TYPE,
} from '../../constants/ActionTypes';

export function getHiddenBlockTypes() {
  return {
    type: GET_HIDDEN_BLOCK_TYPES,
  };
}

export function toggleHiddenBlockType(blockType) {
  return {
    type: TOGGLE_HIDDEN_BLOCK_TYPE,
    blockType: blockType,
  };
}
